import * as icons from '@creditornot/alchemy-react/icons';
import { CopyableButton } from 'common/components/cookbook/CopyableButton';
import { Stack } from 'common/components/cookbook/Stack';
import { TextLink } from 'common/components/cookbook/TextLink';
import { Thumbnail } from 'common/components/cookbook/Thumbnail';
import { useSelectedCountryCodes } from 'common/hooks/useSelectedCountryCodes';
import { useSelectedCountryTranslatedValue } from 'common/hooks/useSelectedCountryTranslatedValue';
import { AssortmentProductLandingPageEnumType } from 'features/assortment/schemas';
import { ProductName } from 'features/pricing/types';

import { SelectionRecommendationsActiveTabEnumType } from '..';

type Props = {
  productId: string;
  productGtin?: string;
  productCode?: string;
  productName: ProductName[];
  imgSrc?: string;
  landingPage?: AssortmentProductLandingPageEnumType;
  currentTab?: SelectionRecommendationsActiveTabEnumType;
};

export const ProductCard = ({
  productId,
  productGtin,
  productCode,
  productName: name,
  imgSrc,
  landingPage,
  currentTab,
}: Props) => {
  const productName = useSelectedCountryTranslatedValue(name);
  const [countryCode] = useSelectedCountryCodes();

  return (
    <Stack direction="row" gap="regularXlarge" alignItems="center">
      <Thumbnail height={40} width={40} imgSrc={imgSrc} altText={productName} />
      <Stack gap="narrowSmall">
        <Stack justifyContent="space-between">
          <TextLink
            target="_blank"
            to="/assortment/products/$countryCode/$productId"
            params={{
              countryCode,
              productId,
            }}
            search={{
              from: `/selection-recommendations?activeTab=${currentTab}`,
              productCode,
              landingPage: landingPage ?? undefined,
            }}
          >
            {productName}
          </TextLink>
        </Stack>
        <Stack direction="row" gap="regularMedium">
          {productGtin && (
            <CopyableButton className="copyable-button" icon={icons.barcode} testId="product-gtin">
              {productGtin}
            </CopyableButton>
          )}
          {productCode && (
            <CopyableButton icon={icons.tag} className="copyable-button">
              {productCode}
            </CopyableButton>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
